
import SearchBar2ndPage from "../SearchBar/SearchBar2ndPage";



const AddToCartPage = () => {
    return (
      <>
        <div className="headerPage2">
    <SearchBar2ndPage/>
        </div>
      </>
    );
  };
  export default AddToCartPage;

  